import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, ArrowUpRight } from "lucide-react";
import Logo, { Wordmark } from "@/components/Logo";
import NotificationBell from "@/components/NotificationBell";

export default function Navbar({ minimal = false }) {
 const { user, logout } = useAuth();
 const navigate = useNavigate();

 return (
 <header className="border-b border-[#E5E4DE] bg-[#FAF9F6]/95 backdrop-blur sticky top-0 z-30" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-16 flex items-center justify-between gap-4">
        <Link
          to="/"
          onClick={(e) => {
            // ScrollToTop handles every route change, but clicking the logo
            // while already on "/" is a no-op for the router, so we manually
            // smooth-scroll to the top in that case.
            if (typeof window !== "undefined" && window.location.pathname === "/") {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }}
          className="flex items-center gap-2.5 shrink-0"
          data-testid="nav-logo"
        >
          <Logo size={26} />
          <Wordmark size={20} />
        </Link>

        {!minimal && (
          <nav className="flex items-center gap-2 sm:gap-6 whitespace-nowrap">
 <Link to="/check" className="text-sm text-[#0D2B52] hover:text-[#1B6C62] font-medium hidden md:inline" data-testid="nav-check">
 Check a rental
 </Link>
 <Link to="/ask" className="text-sm text-[#0D2B52] hover:text-[#1B6C62] font-medium hidden sm:inline" data-testid="nav-brain">
 Ask the Brain
 </Link>
 <Link to="/q" className="text-sm text-[#6B7280] hover:text-[#1A1A1A] hidden md:inline" data-testid="nav-renter-qa">
 Renter Q&amp;A
 </Link>
 <Link to="/features" className="text-sm text-[#6B7280] hover:text-[#1A1A1A] hidden md:inline" data-testid="nav-features">
 Features
 </Link>
 <Link to="/pricing" className="text-sm text-[#6B7280] hover:text-[#1A1A1A] hidden sm:inline" data-testid="nav-pricing">
 Pricing
 </Link>
 <Link to="/guide" className="text-sm text-[#6B7280] hover:text-[#1A1A1A] hidden md:inline" data-testid="nav-guide">
 Help
 </Link>
 {user ? (
 <>
 <Link to="/dashboard" className="text-sm text-[#6B7280] hover:text-[#1A1A1A]" data-testid="nav-dashboard">
 Dashboard
 </Link>
 {(!user.tier || user.tier === "free") && (
 <Link
 to="/pricing"
 className="text-sm font-medium text-[#1B6C62] hover:text-[#0D2B52] hidden sm:inline-flex items-center gap-1 border border-[#1B6C62]/40 hover:border-[#1B6C62] bg-[#E6F5F2]/40 hover:bg-[#E6F5F2] px-2.5 py-1 transition-colors"
 data-testid="nav-upgrade"
 title="Upgrade your plan"
 >
 Upgrade plan
 <ArrowUpRight size={13} strokeWidth={2} />
 </Link>
 )}
 {user.is_admin && (
 <Link to="/admin/insights" className="text-sm text-[#1B6C62] hover:underline hidden md:inline font-medium" data-testid="nav-admin-insights" title="Admin insights">
 Insights
 </Link>
 )}
 <Link to="/account" className="text-sm text-[#6B7280] hover:text-[#1A1A1A] hidden sm:inline" data-testid="nav-account">
 Account
 </Link>
 <NotificationBell />
 <button onClick={logout} className="btn-ghost flex items-center gap-1.5 text-sm" data-testid="nav-logout">
 <LogOut size={16} strokeWidth={1.5} /> Sign out
 </button>
 </>
 ) : (
 <>
 <Link to="/login" className="text-sm text-[#6B7280] hover:text-[#1A1A1A]" data-testid="nav-login">Sign in</Link>
 <button onClick={() => navigate("/register")} className="btn-primary text-sm" data-testid="nav-register">
 Start free
 </button>
 </>
 )}
 </nav>
 )}
 </div>
 </header>
 );
}
